import React from "react";
import { Navigate, useParams } from "react-router-dom";
import Users from "./Users";
import { getResourceRoleFromSlug } from "./resourceRoleConfig";

/**
 * /resources/:roleSlug — same Users list with a fixed role filter (Trainer, Counselor, …).
 */
const ResourceUsersPage = () => {
  const { roleSlug } = useParams();
  const resourceRoleConfig = getResourceRoleFromSlug(roleSlug);

  if (!resourceRoleConfig) {
    return <Navigate to="/users" replace />;
  }

  return <Users resourceRoleConfig={resourceRoleConfig} />;
};

export default ResourceUsersPage;
